import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Observable } from 'rxjs';

// Services
import { ApiService } from './api.service';
import { ConfigService } from './config.service';
import { DataService } from './data.service';

declare let jQuery: any;
@Injectable()
export class SeoService {
	public defaultMeta: any = {
		title: 'DIE SPIELBANK | Online Slots. Entspannt. Sicher. Legal 🎰',
		description: 'Hier Spielt Deutschland 💎 DIE SPIELBANK bietet eine Riesenauswahl an Online-Spielautomaten (Slots). Mit deutscher Lizenz. Sicher und legal. Jetzt spielen',
	};
	private link!: HTMLLinkElement;
	private lastCanonicalUrl: string | null = null;
	
	constructor(
		public meta: Meta,
		public titleService: Title,
		private _configService: ConfigService,
		private _apiService: ApiService,
		private router: Router,
		private _dataService: DataService,
		@Inject(PLATFORM_ID) private platformId: Object,
		@Inject(DOCUMENT) private doc
	) { }

	public updateMetaTag(data: any, pageName: any, gameMetaData: any = null, ogTagData: any = null) {
		if (!data) {
			return;
		}
		let metaData: any = {};
		let seo = data.seo;


		if (seo[pageName]) {
			metaData = seo[pageName];
		}

		if (gameMetaData) {
			metaData = gameMetaData;
		}

		let metaTitle = metaData.title;
		if (metaTitle) {
			metaTitle = metaTitle.replace('&amp;#', '&#');
		}

		let metaDescription = metaData.description;
		if (metaDescription) {
			metaDescription = metaDescription.replace('&amp;#', '&#');
		}

		let headerPageAssets = this._dataService.getAssets('headerPage');
		let ogImage = '';
		if (headerPageAssets.digital) {
			ogImage = headerPageAssets.digital.touch_icon;
		}
		if (ogTagData) {
			ogImage = ogTagData['ogImage'] || '';
		}



		this.titleService.setTitle(this.decodeStr(metaTitle) || this.defaultMeta.title);
		this.meta.updateTag({ name: 'title', content: this.decodeStr(metaTitle) || this.defaultMeta.title });
		this.meta.updateTag({ name: 'keywords', content: this.decodeStr(metaData.keywords) });
		this.meta.updateTag({ name: 'description', content: this.decodeStr(metaDescription) || this.defaultMeta.description });
		this.meta.updateTag({ property: 'og:type', content: 'Website' });
		this.meta.updateTag({ property: 'og:title', content: metaTitle || this.defaultMeta.title });
		this.meta.updateTag({ property: 'og:description', content: metaDescription || this.defaultMeta.description });
		this.meta.updateTag({ property: 'og:site_name', content: 'DIE-SPIELBANK.de' });
		this.meta.updateTag({ property: 'og:url', content: this.getSiteDomain() });
		this.meta.updateTag({ property: 'og:image', content: ogImage });
	}

	decodeStr(val: any) {
		if (isPlatformBrowser(this.platformId)) {
			return jQuery('<span />').html(val).text()
		} else {
			return val;
		}
	}

	public updateMetaTagNoIndex(val: any) {
		// if (val) {
		// 	this.meta.updateTag({ name: 'robots', content: val });
		// } else {
		// 	this.meta.removeTag('name="robots"');
		// }
	}

	getSiteDomain() {
		return this._configService.getSiteDomain() + this.router.url;
	}

	setCanonicalURL(url?: string) {
		const canURL = (url == undefined) ? this.doc.URL : url;
		// Skip if canonical URL has not changed
		if (this.lastCanonicalUrl === canURL) {
			return;
		}
		this.lastCanonicalUrl = canURL;
		// Remove any existing canonical links before adding a new one
		const existingLinks = this.doc.querySelectorAll('link[rel="canonical"]');
		existingLinks.forEach((link: any) => link.remove());
		// Create a fresh canonical link
		this.link = this.doc.createElement('link');
		this.link.setAttribute('rel', 'canonical');
		this.link.setAttribute('href', canURL);
		this.doc.head.appendChild(this.link);
	}

}
